import React from 'react';
import { smoothScrollTo } from '../hooks/useGSAPAnimations';
import { HugeiconsIcon } from '@hugeicons/react';
import { Download01Icon } from '@hugeicons/core-free-icons';

const SectionCTA = ({ className = '', variant = 'primary' }) => {
  const handleClick = () => {
    smoothScrollTo('#form');
  };

  if (variant === 'secondary') {
    return (
      <div className={`hidden lg:flex justify-center ${className}`}>
        <button
          onClick={handleClick}
          className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-golf-green text-golf-green hover:bg-golf-green hover:text-white font-inter font-semibold text-base px-8 py-3 min-h-[48px] rounded-lg transition-all duration-300 shadow-md hover:shadow-xl text-center cursor-pointer"
        >
          <HugeiconsIcon icon={Download01Icon} size={20} />
          <span>Get Your Free Guide</span>
        </button>
      </div>
    );
  }

  return (
    <div className={`hidden lg:flex justify-center ${className}`}>
      <button
        onClick={handleClick}
        className="inline-flex items-center justify-center gap-2 cta-button text-white font-inter font-bold text-base px-8 py-3 min-h-[48px] rounded-lg shadow-luxury text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
      >
        <HugeiconsIcon icon={Download01Icon} size={20} />
        <span>Get Your Free Guide Now</span>
      </button>
    </div>
  );
};

export default SectionCTA;
